import { Alert, AlertTitle } from '@mui/material';

export const ManualEntryBanner = ({ supplierName }: { supplierName: string }) => (
  <Alert severity="warning">
    <AlertTitle>This invoice couldn&apos;t be parsed automatically</AlertTitle>
    {`Add line items so ${supplierName} is included in the current spend baseline.`}
  </Alert>
);
